import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class RiskToleranceAssessmentsService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getRiskToleranceAssessmentsList(params) {
        const url = this.urlsService.RTQ.ASSESSMENT_LIST_COLLECTION;
        return this.ajaxService.getDataObserveBody(url, params);
    }
    exportRTQAssessmentPDF(assessmentId, xAxisMetric, yAxisMetric) {
        const url = this.urlsService.getUrl(this.urlsService.RTQ.PDF_EXPORT, { assessmentId });
        const params = { x_axis_metric: xAxisMetric, y_axis_metric: yAxisMetric };
        return this.ajaxService.getDataObserveBody(url, params);
    }
    exportRTQRegistrationRiskProfilePDF(registrationId, xAxisMetric, yAxisMetric, clientPortfolio = null, associatedModelId = null) {
        const url = this.urlsService.getUrl(this.urlsService.RTQ.REGISTRATION_RP_PDF_EXPORT, { registrationId });
        const params = { x_axis_metric: xAxisMetric, y_axis_metric: yAxisMetric };
        if (clientPortfolio !== null) {
            params.client_portfolio = String(clientPortfolio);
        }
        if (associatedModelId !== null) {
            params.associated_model_id = String(associatedModelId);
        }
        return this.ajaxService.getDataObserveBody(url, params);
    }
}
RiskToleranceAssessmentsService.ɵfac = function RiskToleranceAssessmentsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskToleranceAssessmentsService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
RiskToleranceAssessmentsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RiskToleranceAssessmentsService, factory: RiskToleranceAssessmentsService.ɵfac, providedIn: 'root' });
